module.exports = __webpack_public_path__ + "img/3.45c9c0ef.png";